import React from "react";
import Modal from "react-modal";

import { Schedule, ScheduleItemType } from "../../../../models";
import { ScheduleDriverWidget } from "../../ScheduleDriverWidget/ScheduleDriverWidget";
import { Map } from "./Map";

import { ReactComponent as Close } from "../../../../assets/images/close.svg";
import "./ScheduleDetailsModal.scss";

const modalStyles = {
  content: {
    display: "flex",
    flex: 1,
    margin: 40,
    padding: 0,
    backgroundColor: "#FFFFFF",
  },
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
};

export interface ScheduleDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSetVehicle: () => void;

  schedule?: Schedule;
}

export const ScheduleDetailsModal: React.FC<ScheduleDetailsModalProps> = ({
  isOpen,
  onClose,
  onSetVehicle,
  schedule,
}) => {
  const filteredDeliveries = (schedule?.scheduleItems || []).filter(
    (i) => i.type === ScheduleItemType.DELIVERY
  );
  const filteredPickups = (schedule?.scheduleItems || []).filter(
    (i) => i.type === ScheduleItemType.PICK_UP
  );
  const filteredDumpYards = (schedule?.scheduleItems || []).filter(
    (i) => i.type === ScheduleItemType.DUMP_YARD
  );

  if (!schedule) return null;

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      <div className="schedule-details-modal-component">
        <div className="close-container">
          <Close className="close-button" onClick={onClose} />
        </div>

        <div className="main-container">
          <ScheduleDriverWidget
            schedule={schedule}
            onMapPress={() => undefined}
            onSetVehicle={onSetVehicle}
            onSettingsClick={() => undefined}
          />

          <Map
            scheduleItems={schedule.scheduleItems}
            deliveries={filteredDeliveries}
            pickups={filteredPickups}
            dumpYards={filteredDumpYards}
          />
        </div>
      </div>
    </Modal>
  );
};
